export default function Footer() {
  return (
    <div className="text-center mt-auto mb-3 mx-5">
      <p>&copy;2022 Invently LLC</p>
    </div>
  );
}
